<template>
  <div class="col-12" style="display: flex;">
    <div style="min-width: 70%;">
      <div class="nps-display-values">
        <div class="idx-card-title">{{ graphTitle }}</div>
        <div class="nps-chart">
          <radial-progress-bar
            v-if="nps !== null && nps !== undefined"
            :diameter="240"
            :stroke-width="20"
            innerStrokeColor="#f1f1f1"
            :startColor="colorBalance"
            :stopColor="colorBalance"
            :completed-steps="completedSteps ? parseFloat(completedSteps) : 0"
            :total-steps="totalSteps"
          >
            <b
              :id="`number-nps-${graphType}`"
              :style="{
                color: colorBalance,
                fontSize: '2.8em',
                fontWeight: 'bold',
              }"
              >{{ completedSteps }}</b
            >
            <b-tooltip
              :id="`tooltip-${graphType}`"
              v-if="nps !== null && nps !== undefined"
              :target="`number-nps-${graphType}`"
              placement="bottom"
            >
              {{ toolTipMsg }}
              <strong>{{ completedSteps }}</strong>
            </b-tooltip>
          </radial-progress-bar>
          <div v-else>{{ this.$t('reports.npsBar.noDataMsg') }}</div>
        </div>
      </div>
    </div>
    <div style="min-width: 30%; text-align: center;">
      <div class="board-percentil" style="padding-top: 60px;">
        <span class="board-percentil-label">
          {{ this.$t('reports.npsBar.promoterLabel') }}
        </span>
        <br />
        <strong class="board-percentil-percent">
          {{
            this.totalAnswers
              ? ((100 * this.promoters) / this.totalAnswers).toFixed(0)
              : 0
          }}%
        </strong>
        /
        <span class="board-percentil-value">
          {{ this.promoters }}
        </span>
      </div>
      <div class="board-percentil">
        <span class="board-percentil-label">
          {{ this.$t('reports.npsBar.neutralLabel') }}
        </span>
        <br />
        <strong class="board-percentil-percent">
          {{
            this.totalAnswers
              ? ((100 * this.passives) / this.totalAnswers).toFixed(0)
              : 0
          }}%
        </strong>
        /
        <span class="board-percentil-value">
          {{ this.passives }}
        </span>
      </div>
      <div class="board-percentil">
        <span class="board-percentil-label">
          {{ this.$t('reports.npsBar.detractorLabel') }}
        </span>
        <br />
        <strong class="board-percentil-percent">
          {{
            this.totalAnswers
              ? ((100 * this.detractors) / this.totalAnswers).toFixed(0)
              : 0
          }}%
        </strong>
        /
        <span class="board-percentil-value">
          {{ this.detractors }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import EventBus from '../../../eventBus';

export default {
  name: 'npsBarValues',
  props: [
    'graphTitle',
    'selectedBranch',
    'selectedGroup',
    'allBranches',
    'graphType',
  ],
  components: {
    RadialProgressBar,
    animatedNumber,
  },
  data: () => ({
    userAuth: null,
    completedSteps: null,
    totalSteps: 100,
    toolTipMsg: '',
    colorBalance: '#fff',
    branchName: null,
    groupIh1: [],
    totalAnswers: 0,
    promoters: 0,
    passives: 0,
    detractors: 0,
  }),
  watch: {
    actionGroupData: function watchActionGroup() {
      this.refreshData().then(() => {
        EventBus.$emit('load-nps');
      });
    },
    myActionId: function watchMyActionId() {
      this.refreshData().then(() => {
        EventBus.$emit('load-nps');
      });
    },
    myIh1: function watchMyIh1() {
      this.refreshData().then(() => {
        EventBus.$emit('load-nps');
      });
    },
    myIh2: function watchMyIh2() {
      this.refreshData().then(() => {
        EventBus.$emit('load-nps');
      });
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.refreshData().then(() => {
        EventBus.$emit('load-nps');
      });
    },
    calendarDates: function watchDates() {
      this.refreshData().then(() => {
        EventBus.$emit('load-nps');
      });
    },
    myMetric: function watchMyMetric() {
      this.changeLabel();
      this.refreshData().then(() => {
        EventBus.$emit('load-nps');
      });
    },
    'indicatorData.value': function watchIndicatorDataValue() {
      this.refreshData().then(() => {
        EventBus.$emit('load-nps');
      });
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      this.refreshData().then(() => {
        EventBus.$emit('load-nps');
      });
    },
  },
  computed: {
    ...mapState('dashboard', ['nps', 'percentilNps']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapFields('branches', ['ih1']),
  },
  methods: {
    ...mapActions('dashboard', ['getNps', 'getNpsByDate', 'getMetricValue']),
    ...mapActions('calendar', ['setDefaultDates']),
    ...mapActions('branches', ['listBranchesIh1']),
    formatToPrice(value) {
      if (value) {
        return value.toFixed(0);
      }
      return 0;
    },
    async refreshData() {
      await this.getMetricValue({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.groupIh1,
        // ih1: this.myIh1 === '0' ? null : this.myIh1,
        branchGroup: this.selectedGroup,
        allBranches: this.allBranches,
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      });
      this.setColorNps(this.nps);
      this.completedSteps = this.nps ? this.nps.toFixed(2) : null;
      this.promoters = this.percentilNps.promoters;
      this.passives = this.percentilNps.passive;
      this.detractors = this.percentilNps.detractors;
      this.totalAnswers = this.promoters + this.passives + this.detractors;
    },
    setColorNps(percentBalace) {
      if (percentBalace >= 80) {
        this.colorBalance = '#6bca6c';
      } else if (percentBalace < 80 && percentBalace >= 70) {
        this.colorBalance = '#9fd77a';
      } else if (percentBalace < 70 && percentBalace >= 50) {
        this.colorBalance = '#fbcf3f';
      } else if (percentBalace < 50 && percentBalace >= 0) {
        this.colorBalance = '#fa834f';
      } else if (percentBalace < 0) {
        this.colorBalance = 'red';
      }
    },
    changeLabel() {
      if (this.myMetric.indexOf('nps') !== -1) {
        this.totalSteps = 100;
        this.toolTipMsg = this.$t('reports.npsBar.npsMessage');
      } else if (this.myMetric.indexOf('ces') !== -1) {
        this.totalSteps = 5;
        this.toolTipMsg = this.$t('reports.npsBar.cesMessage');
      }
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
  async mounted() {
    this.changeLabel();
    await this.listBranchesIh1({
      companyId: this.userAuth.companyId,
      token: this.userAuth.token,
    });
    this.groupIh1 = [];
    this.groupIh1 = this.myIh1 === '0' ? null : this.myIh1;
    if (this.selectedBranch) {
      this.groupIh1 = this.selectedBranch;
      // eslint-disable-next-line no-plusplus
      for (let j = 0; j < this.ih1.listFilters.length; j++) {
        if (this.selectedBranch === this.ih1.listFilters[j]._id.toString()) {
          this.branchName = this.ih1.listFilters[j].corporate_name;
          break;
        }
      }
    } else if (this.allBranches) {
      this.groupIh1 = null;
    }
    this.refreshData().then(() => {
      EventBus.$emit('load-nps');
    });
    EventBus.$on('refresh', async () => {
      this.setDefaultDates();
      this.refreshData();
    });
  },
  beforeDestroy() {
    EventBus.$off('refresh');
  },
};
</script>

<style lang="scss">
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.nps-display-values {
  padding: 18px 0;
  flex-direction: column;
  border-radius: 4px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
  .idx-card-title {
    height: 30px;
    padding-left: 20px;
    text-align: left;
    width: 100%;
    font-weight: 100;
    color: #5f6368;
    font-size: 18px;
  }
  .nps-chart {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 30px);
  }
}
.board-percentil {
  padding: 20px 0px 20px 20px;
  min-width: 150px;
}
.board-percentil-label {
  font-size: 14px;
}
.board-percentil-percent {
  font-size: 20px;
}
.board-percentil-value {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/nps-bar-values/index.vue